import { render } from "./ForgotView.vue?vue&type=template&id=3cf2b0b6&scoped=true"
import script from "./ForgotView.vue?vue&type=script&lang=js"
export * from "./ForgotView.vue?vue&type=script&lang=js"

import "./ForgotView.vue?vue&type=style&index=0&id=3cf2b0b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf2b0b6"]])

export default __exports__